export const colors = [
  '#90efff',
  '#8edcee',
  '#8cc9dc',
  '#88b6cb',
  '#84a3ba',
  '#7f91aa',
  '#7a7f99',
  '#746e89',
  '#6d5c79',
  '#664c69',
  '#5e3b5a',
  '#552a4a',
  '#4c193b',
  '#40082a'
];

export const colorsDark = [
  '#2a737f',
  '#1f6a79',
  '#246677',
  '#2c5c6e',
  '#325166',
  '#34465c',
  '#343a51',
  '#342f47',
  '#31233c',
  '#2f1832',
  '#2b0c29',
  '#27001f',
  '#270017',
  '#25000a'
];

export const colorsBright = [
  '#e1fbff',
  '#e5f7fb',
  '#e4f2f7',
  '#e7f0f4',
  '#e9eef2',
  '#e9ecf1',
  '#eaebef',
  '#eae9ed',
  '#eae8ec',
  '#e7e3e8',
  '#e6e0e5',
  '#e4dde2',
  '#e3dae0',
  '#e0d8dd'
];

export const startBrands = [
  ['BMW', 'Mercedes', 'VW'],
  ['BMW', 'Tesla', 'VW'],
  ['Opel', 'Ford', 'Seat'],
  ['Audi', 'Ford', 'Renault'],
  ['Skoda', 'Subaru', 'VW'],
  ['Hyundai', 'VW', 'Toyota']
  
];

const config = {
  'GROSSRAUM-VANS': {
    color: colors[12],
    colorDark: colorsDark[12],
    colorBright: colorsBright[12],
    label: 'Großraum-Vans',
    labelMobile: false,
    labelXPos: 2014,
    labelFontSize: '12px',
    labelFontSizeMobile: '10px'
  },
  KLEINWAGEN: {
    color: colors[1],
    colorDark: colorsDark[1],
    colorBright: colorsBright[1],
    label: 'Kleinwagen',
    labelXPos: 2010,
    labelFontSize: '16px',
    labelFontSizeMobile: '12px',
    showIcon: true
  },
  KOMPAKTKLASSE: {
    color: colors[4],
    colorDark: colorsDark[4],
    colorBright: colorsBright[4],
    label: 'Kompaktklasse',
    labelXPos: 2010,
    labelFontSize: '16px',
    labelFontSizeMobile: '12px',
    showIcon: true
  },
  'MINI-VANS': {
    color: colors[7],
    colorDark: colorsDark[7],
    colorBright: colorsBright[7],
    label: 'Mini-Vans',
    labelXPos: 2014,
    labelFontSize: '12px',
    labelFontSizeMobile: '10px'
  },
  MINIS: {
    color: colors[3],
    colorDark: colorsDark[3],
    colorBright: colorsBright[3],
    label: 'Minis',
    labelXPos: 2010,
    labelFontSize: '12px',
    labelFontSizeMobile: '10px'
  },
  MITTELKLASSE: {
    color: colors[9],
    colorDark: colorsDark[9],
    colorBright: colorsBright[9],
    label: 'Mittelklasse',
    labelXPos: 2010,
    labelFontSize: '16px',
    labelFontSizeMobile: '12px',
    showIcon: true
  },
  OBEREMITTELKLASSE: {
    color: colors[10],
    colorDark: colorsDark[10],
    colorBright: colorsBright[10],
    label: 'Obere Mittelklasse',
    labelXPos: 2010,
    labelFontSize: '12px',
    labelFontSizeMobile: '10px'
  },
  OBERKLASSE: {
    color: colors[12],
    colorDark: colorsDark[12],
    colorBright: colorsBright[12],
    label: 'Oberklasse',
    labelXPos: 2014,
    labelFontSize: '12px',
    labelFontSizeMobile: '10px'
  },
  SONSTIGE: {
    color: colors[1],
    colorDark: colorsDark[1],
    colorBright: colorsBright[1],
    label: 'Sonstige',
    labelMobile: false,
    labelXPos: 2017,
    labelFontSize: '12px',
    labelFontSizeMobile: '10px'
  },
  SPORTWAGEN: {
    color: colors[12],
    colorDark: colorsDark[12],
    colorBright: colorsBright[12],
    label: 'Sportwagen',
    labelXPos: 2010,
    labelFontSize: '12px',
    labelFontSizeMobile: '10px'
  },
  SUV_GELAENDEWAGEN: {
    color: colors[12],
    colorDark: colorsDark[12],
    colorBright: colorsBright[12],
    label: 'SUV + Geländewagen',
    labelXPos: 2018,
    xOffset: scale => {
      return scale.step() * 0.7;
    },
    labelFontSize: '20px',
    labelFontSizeMobile: '12px',
    showIcon: true,
    textAnchor: 'end'
  },
  UTILITIES: {
    color: colors[12],
    colorDark: colorsDark[12],
    colorBright: colorsBright[12],
    label: 'Transporter',
    labelMobile: false,
    labelXPos: 2010,
    labelFontSize: '12px',
    labelFontSizeMobile: '10px'
  },
  WOHNMOBILE: {
    color: colors[13],
    colorDark: colorsDark[13],
    colorBright: colorsBright[13],
    label: 'Wohnmobile',
    labelXPos: 2017,
    labelFontSize: '12px',
    labelFontSizeMobile: '10px'
  },
  INSGESAMT: {
    color: colors[6],
    colorDark: colorsDark[6],
    colorBright: colorsBright[6],
    label: 'Insgesamt'
  }
};

export default config;
